import { css } from '@emotion/css';

export const buttonContentClassName = css({
  '&&': {
    display: 'flex',
    alignItems: 'center',
  },
});
